import { WaveBlockKind } from "./types.js";
import { isWaveImageSourceBlock, resolveCoalescedGalleryTargetBlockId, sourceBlockIdsFromCoalescedFeedBlockId, } from "./waveImageCoalesce.js";
import { isWaveBlockArchived } from "./waveThreadProjection.js";
function isActiveGallery(block) {
    return block.kind === WaveBlockKind.Gallery && !isWaveBlockArchived(block);
}
function isActiveImageFile(block) {
    return block.kind === WaveBlockKind.File && isWaveImageSourceBlock(block) && !isWaveBlockArchived(block);
}
function migrateImageFileBlockToGallery(editor, fileBlock) {
    const blocks = editor.blocks;
    const idx = blocks.findIndex((b) => b.id === fileBlock.id);
    const afterPred = idx > 0 ? blocks[idx - 1].id : null;
    const gallery = editor.appendBlock(WaveBlockKind.Gallery, afterPred);
    editor.setText(gallery.id, "title", "Galleria");
    if (fileBlock.payload.s3Key) {
        const item = editor.addGalleryItem(gallery.id, {
            fileName: fileBlock.payload.fileName,
            mimeType: fileBlock.payload.mimeType,
            fileSize: fileBlock.payload.fileSize,
            uploadStatus: fileBlock.payload.uploadStatus ?? "ready",
        });
        editor.setGalleryItemMeta(gallery.id, item.id, {
            s3Key: fileBlock.payload.s3Key,
            mimeType: fileBlock.payload.mimeType,
            fileName: fileBlock.payload.fileName,
            fileSize: fileBlock.payload.fileSize,
            uploadStatus: fileBlock.payload.uploadStatus ?? "ready",
        });
    }
    editor.removeBlock(fileBlock.id);
    return gallery.id;
}
function appendNewGallery(editor, afterBlockId) {
    const block = editor.appendBlock(WaveBlockKind.Gallery, afterBlockId ?? null);
    editor.setText(block.id, "title", "Galleria");
    return block.id;
}
/**
 * Real Yjs GALLERY block id for uploads on a specific widget (drop on gallery, picker, etc.).
 */
export function resolveGalleryBlockIdForMutation(editor, blocks, blockId) {
    const coalesced = resolveCoalescedGalleryTargetBlockId(blocks, blockId);
    if (coalesced) {
        const target = blocks.find((b) => b.id === coalesced);
        if (target && isActiveGallery(target))
            return coalesced;
    }
    const sourceIds = sourceBlockIdsFromCoalescedFeedBlockId(blockId);
    if (sourceIds?.length) {
        for (const id of sourceIds) {
            const b = blocks.find((x) => x.id === id);
            if (b && isActiveImageFile(b)) {
                return migrateImageFileBlockToGallery(editor, b);
            }
        }
    }
    const direct = blocks.find((b) => b.id === blockId);
    if (direct && isActiveGallery(direct))
        return blockId;
    return blockId;
}
/**
 * Target gallery for editor-level drops (composer / canvas bottom).
 * Always appends a new GALLERY after the anchor — never reuses an existing one.
 * Drop directly on a gallery widget uses {@link resolveGalleryBlockIdForMutation} instead.
 */
export function resolveGalleryBlockId(editor, blocks, afterBlockId) {
    const anchorId = afterBlockId ?? null;
    if (anchorId != null) {
        const anchor = blocks.find((b) => b.id === anchorId);
        if (anchor && isActiveImageFile(anchor)) {
            return migrateImageFileBlockToGallery(editor, anchor);
        }
        return appendNewGallery(editor, anchorId);
    }
    return appendNewGallery(editor, null);
}
